module.exports = __webpack_public_path__ + "static/loyalty_card-3cef0c79c3ead3cea370682af85789ad.jpg";